var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity_box"},[_vm._v(" 模板三 ")])}
var staticRenderFns = []

export { render, staticRenderFns }